/**
 * @generated SignedSource<<f27c9521a2c85ef72a7d1081314f5ffe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubscriberVisibilityKind = "AFTER_DATE_TIME" | "HIDDEN" | "NOT_AFTER_DATE_TIME" | "ONLY_ADMINS" | "ONLY_AZAV_ACCOUNTS" | "ONLY_BUSINESS_ACCOUNTS" | "ONLY_EDITORS" | "ONLY_WITH_LICENSE" | "VISIBLE";
export type VisibilityTreeConfigType = "VisibilityTree_AfterDateTime" | "VisibilityTree_Hide" | "VisibilityTree_NotAfterDateTime" | "VisibilityTree_OnlyAZAVAccount" | "VisibilityTree_OnlyAdmins" | "VisibilityTree_OnlyBusinessAccount" | "VisibilityTree_OnlyEditors" | "VisibilityTree_OnlyIfTreeState" | "VisibilityTree_OnlyPermissionsImpl" | "VisibilityTree_OnlyWithLicense";
export type SubscriberVisibilityInput = {
  dateTime?: string | null;
  kind: SubscriberVisibilityKind;
};
export type editSubscriberConfigButton_EditSubscriberConfigMutation$variables = {
  certificationProductId?: string | null;
  courseContentProductId?: string | null;
  imageId?: string | null;
  licenseProductId?: string | null;
  offerId: string;
  title?: string | null;
  visibility?: SubscriberVisibilityInput | null;
};
export type editSubscriberConfigButton_EditSubscriberConfigMutation$data = {
  readonly Admin: {
    readonly Offer: {
      readonly editSubscriberConfig: {
        readonly certificationProduct: {
          readonly id: string;
          readonly title: string;
        } | null;
        readonly courseContentProduct: {
          readonly id: string;
          readonly title: string;
        } | null;
        readonly image: {
          readonly id: string;
          readonly url: string | null;
        } | null;
        readonly licenseProduct: {
          readonly id: string;
          readonly title: string;
        } | null;
        readonly selectedVersion: number;
        readonly title: string | null;
        readonly visibilityConfigs: ReadonlyArray<{
          readonly configType: VisibilityTreeConfigType;
          readonly dateTime?: string;
        }>;
      };
    };
  };
};
export type editSubscriberConfigButton_EditSubscriberConfigMutation = {
  response: editSubscriberConfigButton_EditSubscriberConfigMutation$data;
  variables: editSubscriberConfigButton_EditSubscriberConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "certificationProductId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseContentProductId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "licenseProductId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "visibility"
},
v7 = [
  {
    "kind": "Variable",
    "name": "certificationProductId",
    "variableName": "certificationProductId"
  },
  {
    "kind": "Variable",
    "name": "courseContentProductId",
    "variableName": "courseContentProductId"
  },
  {
    "kind": "Variable",
    "name": "imageId",
    "variableName": "imageId"
  },
  {
    "kind": "Variable",
    "name": "licenseProductId",
    "variableName": "licenseProductId"
  },
  {
    "kind": "Variable",
    "name": "offerId",
    "variableName": "offerId"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  },
  {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configType",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dateTime",
    "storageKey": null
  }
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "AfterDateTimeVisibilityTreeConfig",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "NotAfterDateTimeVisibilityTreeConfig",
  "abstractKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedVersion",
  "storageKey": null
},
v16 = [
  (v9/*: any*/),
  (v8/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "licenseProduct",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "courseContentProduct",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "certificationProduct",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "editSubscriberConfigButton_EditSubscriberConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "OfferSubscriberConfig",
                "kind": "LinkedField",
                "name": "editSubscriberConfig",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visibilityConfigs",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "editSubscriberConfigButton_EditSubscriberConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "OfferSubscriberConfig",
                "kind": "LinkedField",
                "name": "editSubscriberConfig",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visibilityConfigs",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e553458e7e44d592e3f41471fb04f3bc",
    "id": null,
    "metadata": {},
    "name": "editSubscriberConfigButton_EditSubscriberConfigMutation",
    "operationKind": "mutation",
    "text": "mutation editSubscriberConfigButton_EditSubscriberConfigMutation(\n  $offerId: ID!\n  $title: String\n  $imageId: ID\n  $visibility: SubscriberVisibilityInput\n  $licenseProductId: ID\n  $courseContentProductId: ID\n  $certificationProductId: ID\n) {\n  Admin {\n    Offer {\n      editSubscriberConfig(offerId: $offerId, title: $title, imageId: $imageId, visibility: $visibility, licenseProductId: $licenseProductId, courseContentProductId: $courseContentProductId, certificationProductId: $certificationProductId) {\n        title\n        image {\n          id\n          url\n        }\n        visibilityConfigs {\n          __typename\n          configType\n          ... on AfterDateTimeVisibilityTreeConfig {\n            dateTime\n          }\n          ... on NotAfterDateTimeVisibilityTreeConfig {\n            dateTime\n          }\n          id\n        }\n        selectedVersion\n        licenseProduct {\n          id\n          title\n        }\n        courseContentProduct {\n          id\n          title\n        }\n        certificationProduct {\n          id\n          title\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "62f685f6b8eae9dd08ea29bcb9450f0b";

export default node;
